import script from "./StudiesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudiesView.vue?vue&type=script&setup=true&lang=ts"

import "./StudiesView.vue?vue&type=style&index=0&id=78114820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78114820"]])

export default __exports__